import Constants from '@/Constants';
import Category from '@/models/Category';
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../style.scss';

interface Props {
    categoryType: Category;
}

const CategoryItem: React.FC<Props> = (props: Props) => {
    const { categoryType } = props;
    return (
        <NavLink className="category-section list item" draggable={false} exact to={`${Constants.CATEGORY}/${categoryType.id}`}>
            {categoryType.name}
        </NavLink>
    );
};

export default CategoryItem;
